const programme = {
  path: "/programme",
  name: "programme",
  redirect: "/programme/indexMI",
  component: {
    render: c => c("router-view")
  },
  title: "解决方案",
  children: [
    {
      path: "/programme/indexMI",
      name: "indexMI",
      component: () => import("@/views/programme/indexMI.vue"),
      title: "母婴"
    },
    {
      path: "/programme/indexBM",
      name: "indexBM",
      component: () => import("@/views/programme/indexBM.vue"),
      title: "美妆"
    }
  ]
};

export default programme;
